import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {SmNavMenuItemComponent} from './sm-nav-menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
  ],
  declarations: [SmNavMenuItemComponent],
  exports: [SmNavMenuItemComponent],
})
export class SmNavMenuItemModule {}
